import axios from "axios";

const getCheckoutLink = async (planType: string, planName?: string): Promise<string> => {
    const params: Record<string, string> = { planType };
    if (planName) params.planName = planName;
    const { data } = await axios.get("subscriptions/checkout-link", { params });
    return data;
};

export default getCheckoutLink;
